(function ($) {
  'use strict';

  Drupal.behaviors.eventListings = {
    attach: function (context) {
      // Reinitialize slider on window size change.
      $(window).resize(function () {
        $('.event-listings__list.active', context).slick('resize');
      });
      // Hold this in function for reuse.
      const slickEventListings = () => {
        $('.event-listings__list.active', context)
          .not('.slick-initialized')
          .slick({
            mobileFirst: true,
            slidesToShow: 1,
            prevArrow: '.event-listings__slider-prev',
            nextArrow: '.event-listings__slider-next',
            dots: true,
            responsive: [
              {
                breakpoint: 639,
                settings: 'unslick'
              },
            ]
          });
      };

      $('.event-listings__category-button', context).click(function () {
        // Get list target.
        const listTarget = $(this).data('listTarget');

        // Set button classes.
        $('.event-listings__category-button', context).removeClass('active');
        $(this).addClass('active');
        $('.event-listings__view-all-button', context).removeClass('active');
        $(`.event-listings__view-all-button[data-list-target='${listTarget}']`)
          .addClass('active');

        // Set list classes.
        $('.event-listings__list.active', context).slick('unslick')
          .removeClass('active');
        $(`.event-listings__list[data-list-target="${listTarget}"]`, context)
          .addClass('active');

        // Reinit slick on new list.
        slickEventListings();
      });

      // Initial setup of slider on page load.
      slickEventListings();
      $('.event-listing__list-item').attr('tabindex', '-1');
    }
  };
}(jQuery));
